import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
 
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
 
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const role = localStorage.getItem("role");
      navigate(role === "admin" ? "/admin-dashboard" : "/user-dashboard");
    }
  }, [navigate]);
 
  const validateForm = () => {
    const newErrors = {};
 
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Enter a valid email";
    }
 
    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
 
    setLoading(true);
    setErrors({});
 
    try {
      const response = await axios.post("https://teams.tidyds.com/api/login", {
        email,
        password,
      });
 
      const { token, role, user } = response.data;
      if (user.status === "disabled") {
        setErrors({ general: "Your account is disabled. Please contact the administrator." });
        setLoading(false);
        return;
      }
 
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("user", JSON.stringify(user));
      navigate(role === "admin" ? "/admin-dashboard" : "/user-dashboard");
    } catch (error) {
      setErrors({ general: "Invalid email or password. Please try again." });
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <section className="login-bg d-flex align-items-center justify-content-center vh-100">
      <style>{`
        .login-bg {
          background: linear-gradient(to bottom, #45048a, #ab1599);
        }
        .logo-img {
          width: 120px;
          height: auto;
        }
        .login-card {
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          width: 100%;
          max-width: 400px;
          padding: 40px 28px;
        }
        .toggle-password {
          position: absolute;
          top: 42px;
          right: 12px;
          cursor: pointer;
          font-size: 14px;
          user-select: none;
          color: #6c757d;
        }
        .sign-button {
          background: linear-gradient(90deg, #45048a, #45048a);
          border: none;
          color: #fff;
          font-weight: 700;
          line-height: 24px;
          padding: 10px;
          transition: background 0.5s ease, transform 0.3s ease, box-shadow 0.3s ease;
        }
        .sign-button:hover {
          color: #ffffff;
          background: linear-gradient(to right, #6b21bf, #6b21bf);
        }
        .sign-button:focus {
          background: linear-gradient(90deg, #45048a, #9747FF);
          color: #ffffff !important;
        }
        .f-p {
          color: #45048a;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
 
        }
        .f-p:hover {
          color: #6b21bf;
        }
        .form-control:focus{
        border: 1px solid #000000 !important;
        box-shadow:none !important;
        }
        .form-label{
        font-size: 14px;
        font-weight: 400;
        line-height:22px;
        color: #000000;
        }
        .wel{
        font-size: 24px;
        font-weight: 600;
        line-height:32px;
        color: #000000;
        }
        .des{
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #000000;
        }
        .form-control{
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #000000;
        padding: 10px;
        border-color: #bdbdbd;
        }
        .form-control:placeholder{
        color: #bdbdbd;
        }
        .form-control:hover{
        border-color: #000000 !important;
        }
      `}</style>
 
      <div className="login-card">
        {/* Logo */}
        <div className="text-center mb-3">
          <img src="./tidy_logo.webp" alt="tidy logo" className="logo-img" />
        </div>
 
        {/* Welcome Text */}
        <h5 className="text-center wel">Welcome!</h5>
        <p className="des" key={ "desc"}>
          Sign in to continue to Task Planner.
        </p>
 
        {errors.general && (
          <p className="text-danger text-center mb-3">{errors.general}</p>
        )}
 
        <form onSubmit={handleLogin} noValidate>
          {/* Email */}
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              placeholder="Enter Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>
 
          {/* Password */}
          <div className="mb-2 position-relative">
            <label className="form-label">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              className={`form-control pe-5 ${errors.password ? "is-invalid" : ""}`}
              placeholder="Enter Your Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
           
            {/* Show eye icon only if password has value */}
            {password && (
              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <img
                    src="/eyeslash.svg"
                    alt="Hide password"
                    width={16}
                    height={16}
                  />
                ) : (
                  <img
                    src="/eye.svg"
                    alt="Show password"
                    width={16}
                    height={16}
                  />
                )}
              </span>
            )}
           
            {errors.password && <div className="invalid-feedback">{errors.password}</div>}
          </div>
 
 
          {/* Forgot Password */}
          <div className="text-end mb-3">
            <button
              type="button"
              onClick={() => navigate("/forgot-password")}
              className="btn btn-link p-0 small f-p"
            >
              Forgot Password?
            </button>
          </div>
 
          {/* Sign in */}
          <button
            type="submit"
            disabled={loading}
            className="btn w-100 sign-button"
          >
            {loading ? "Logging in..." : "Sign in"}
          </button>
        </form>
      </div>
    </section>
  );
};
 
export default Login;
 
 